import { loadData, UserDataProvider } from "../../../Core/UserDataProvider"
import { ResearchSearchParams } from "../../../DataTypes/research"
import { controllers } from "../../Controllers"


class ResearchController {

    // Nothing is persisted here — just candidates to review.
    search = async (params: ResearchSearchParams) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.searchResearchPlaces, {userToken, ...params})
        return response
    }

    // Creates a Lead (status='prefetch') per place_id — fetches Place Details
    // for website/phone but doesn't scrape the site itself; that's the
    // prefetch bot's job (see runPrefetchBot).
    addLeads = async (placeIds: string[], query: string, categoryId?: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const body: any = { userToken, place_ids: placeIds, query }
        if (categoryId) body.category_id = categoryId
        const response = loadData(UserDataProvider.addLeadsFromResearch, body)
        return response
    }

    // Fire-and-forget background enrichment of ALL of this user's leads
    // currently sitting in 'prefetch' — not scoped to a specific selection.
    runPrefetchBot = async () => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.runResearchBotNow, {userToken})
        return response
    }
}

export { ResearchController }
